import React from 'react';
import API from 'shared/constants/api';
import DESCRIPTION from 'shared/constants/seoDescriptions';
import isEmpty from 'lodash/isEmpty';
import TITLE from 'shared/constants/seoTitles';
import HEADER from 'shared/constants/seoHeaders';
import CITIES from 'shared/constants/json/cities.json';
import COUNTRIES from 'shared/constants/json/countries.json';
import TRANSPORTS from 'shared/data/json/transports.json';
import { getSeoTextQuery } from 'shared/helpers/seoText';
import { hrefSet } from 'shared/actions/partsForm';
import { setLocation, setSeoSearchUrl, seoRequest, directSetSeoText } from 'shared/actions/globals';
import COUNT_URL_PARAMS from 'shared/constants/json/seoText/countUrlParams.json';
import { targeting, subjectiveText, replaceSpace, firms } from 'shared/modules';
import { getResultFromStoreByKey } from 'shared/helpers/common';
import { selectedActions, resultsThunks } from 'shared/actions/searchForm';
import Layout from 'desktop/components/Layout/Layout';

import { removeLocaleFromHref } from 'shared/helpers/locale';
import Firms from './Firms';

async function action(data) {
  const { fetch, store, baseUrl, path, query, translate } = data;
  const { globals } = store.getState();
  const { locale, location: storeLocation } = globals;
  const url = removeLocaleFromHref(`${baseUrl}${path}`.replace('//', '/'));
  const currentPage = query.page ? parseFloat(query.page) : 1;

  let seoQuery = {};
  const isClearAvtosalonUrl = url.replace('/katalog-kompaniy', '').length <= 1;

  if (!isClearAvtosalonUrl) {
    seoQuery = await store.dispatch(seoRequest(`${url}`));
    store.dispatch(setSeoSearchUrl({ ...seoQuery, url }));
  }

  if (!isClearAvtosalonUrl && isEmpty(seoQuery)) {
    return null;
  }

  if (seoQuery.location && seoQuery.location.is_country) {
    return null;
  }
  if (storeLocation && storeLocation.is_country) {
    store.dispatch(setLocation(null));
  }

  const location = globals.location || (seoQuery.location && seoQuery.location);
  const q = query ? { page: currentPage, ...query } : {};

  const currentType = seoQuery.tag;
  const locationTitle = (location && location.title) || '';

  const commonArguments = subjectiveText({
    section: (currentType && currentType.name) || '',
    cityTitle: locationTitle,
    cityDescriptions: locationTitle,
    cityHeader: locationTitle,
    location: locationTitle,
    regLocation: locationTitle,
    locationAccusative: locationTitle,
    isRegion: !!location && location.is_region,
    allData: {
      url,
      baseUrl,
      locale,
      translate,
    },
  });
  const seoLocation =
    [...CITIES, ...COUNTRIES].find(item => item.id === (location && location.id)) || {};

  const title = replaceSpace(
    TITLE.FIRM({ ...commonArguments, location: seoLocation.title }, translate),
  );
  const description = replaceSpace(DESCRIPTION.FIRM(commonArguments, translate));
  const metaHeader = replaceSpace(HEADER.FIRM(commonArguments, translate));

  if (location) {
    q.location = location && location.id;
  }

  if (currentType) {
    q.tags = currentType.slug;
  }

  const queryObj = {
    ...(location && location.id ? { location: location.id } : {}),
    ...q,
  };

  store.dispatch(
    hrefSet({
      query: queryObj,
      url: `${baseUrl}${path}`,
    }),
  );
  const { partsForm: { vocabulary: { makes = [], typeWork = [] } } = {} } = store.getState();
  Object.keys(queryObj).forEach(key => {
    switch (key) {
      case 'title':
        store.dispatch(
          selectedActions.set.company({
            id: 1,
            title: q.title,
          }),
        );
        break;
      case 'services':
        store.dispatch(
          selectedActions.set.typeWork(
            typeWork && typeWork.filter(dat => Number(q[key]) === dat.id)[0],
          ),
        );
        break;
      case 'make':
        store.dispatch(
          selectedActions.set.makes(makes && makes.filter(dat => Number(q[key]) === dat.id)[0]),
        );
        break;
      case 'makes':
        store.dispatch(
          selectedActions.set.makes(makes && makes.filter(dat => Number(q[key]) === dat.id)[0]),
        );
        break;
      case 'transport':
        store.dispatch(
          selectedActions.set.transport(TRANSPORTS.filter(dat => Number(q[key]) === dat.id)[0]),
        );
        break;
      default:
        break;
    }
  });
  const newTopQuery = {
    ...queryObj,
    is_top_service: true,
    shuffle: 1,
  };

  if (newTopQuery.makes) {
    newTopQuery.top_makes = newTopQuery.makes;
    delete newTopQuery.makes;
  }

  delete newTopQuery.services;
  const newTopParams = { name: 'topFirms', count: false };

  const result = getResultFromStoreByKey(store, `firms`);
  const isLastPage = !(result && result.next);

  // start seoText logic
  const isUk = locale === 'uk';
  const seoTextQuery = getSeoTextQuery(baseUrl, path, isUk, COUNT_URL_PARAMS.katalog);

  const seoText = await fetch(API.SEO.SEARCH_TEXT(seoTextQuery))
    .then(res => res.json())
    .then(response => (response.err ? null : response));

  store.dispatch(directSetSeoText(seoText));
  // end seoText logic

  if (queryObj.transport)
    seoQuery.transport = TRANSPORTS.filter(dat => Number(queryObj.transport) === +dat.id)[0];

  await Promise.all([
    store.dispatch(resultsThunks.searchFirmsResults(queryObj)),
    store.dispatch(resultsThunks.searchFirmsResults(newTopQuery, newTopParams)),
    targeting(data, seoQuery),
    firms.company(data),
  ]);

  return {
    chunks: ['firms'],
    routeName: 'firms',
    title,
    description,
    page: currentPage,
    shouldSetNoIndex: false,
    shouldSetIndex: true,
    isLastPage,
    component: (
      <Layout withBranding>
        <Firms
          locale={locale}
          currentPage={currentPage}
          metaHeader={metaHeader}
          url={url}
          query={query}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/firms/index.js